import {
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Separator } from "@/components/ui/separator";

const AINutritionDialogContent = () => {
  return (
    <DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto">
      <div className="space-y-4 text-sm">
        <DialogHeader>
          <DialogTitle className="text-theme-0">How We Use AI</DialogTitle>
        </DialogHeader>
        <Separator />

        <Section title="Description">
          <p className="text-theme-2 text-xs leading-relaxed">
            AI-powered study tools including document chat, flashcard
            generation, quiz creation, transcription, and smart note
            enhancement.
          </p>
        </Section>

        <Separator />

        <Section title="Model & Data">
          <InfoRow label="Base Model" value="GPT-4o-mini" />
          <InfoRow label="Trained with User Data" value="No" />
          <div className="space-y-1">
            <InfoRow
              label="Data Shared with Model"
              value="Uploaded documents, user prompt, conversation history"
            />
          </div>
        </Section>

        <Separator />

        <Section title="Privacy & Compliance">
          <div className="space-y-1">
            <InfoRow label="Data Retention" value="30 Days" />
            <p className="text-theme-2 text-xs">
              Files are cached for up to 30 days without usage.
            </p>
          </div>
          <div className="space-y-1">
            <InfoRow label="Data Logging" value="Logs Data" />
            <p className="text-theme-2 text-xs">
              Logged for service improvement.
            </p>
          </div>
          <div className="space-y-1">
            <InfoRow label="PII" value="Not Exposed" />
            <p className="text-theme-2 text-xs">
              Personally identifiable information is not sent to the model.
            </p>
          </div>
        </Section>

        <Separator />

        <Section title="Outputs">
          <div className="space-y-1">
            <InfoRow label="Human in the Loop" value="Yes" />
            <p className="text-theme-2 text-xs">
              Users can send additional instructions to fine-tune outputs and
              review before use.
            </p>
          </div>
        </Section>

        <Separator />

        <Section title="Expected Risks">
          <p className="text-theme-2 text-xs leading-relaxed">
            AI-generated content may contain inaccuracies or incomplete
            information. Always verify important details.
          </p>
        </Section>

        <Separator />

        <Section title="Intended Outcomes">
          <p className="text-theme-2 text-xs leading-relaxed">
            Help students understand complex materials, create study aids, and
            manage academic workload efficiently.
          </p>
        </Section>

        <Separator />

        <div>
          <p className="text-xs text-theme-2 text-center italic">
            BetterCampus uses nutrition fact labels for AI products to increase
            transparency and improve decision making.
          </p>
        </div>
      </div>
    </DialogContent>
  );
};

const Section = ({ title, children }) => (
  <div className="space-y-2">
    <h2 className="font-bold text-theme-0 text-sm">{title}</h2>
    <div className="space-y-2">{children}</div>
  </div>
);

const InfoRow = ({ label, value }) => (
  <div className="flex justify-between items-start gap-4">
    <span className="text-theme-0 font-medium text-xs">{label}</span>
    <span className="text-theme-0 text-right text-xs">{value}</span>
  </div>
);

export default AINutritionDialogContent;
